import StrainReviewCardContainer from "./StrainReviewCardContainer";
export default StrainReviewCardContainer;
